import React, { useRef } from 'react';
import { translate } from 'react-i18next';
import { func, number, array, string, bool } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { ItemFilter, SnapaskLoader } from '@snapask/common-components';

import { LOADING } from '@blueberry/constants/loadingState';

import QuestionBlock from '@blueberry/components/QuestionBlock';

import {
  getQuizzes,
  getCurrentQuizIndex,
  actions,
  getStatus,
  getHasNextQuiz,
  getConcepts,
  getSelectedConceptIndex,
} from '@blueberry/redux/post';

import QuizNumberList from './components/QuizNumberList';
import AnswerBlock from './components/AnswerBlock';

import styles from './QuizBlock.scss';

import quizBlockTheme from './questionBlockTheme.scss';

const mapStateToProps = state => ({
  quizzes: getQuizzes(state),
  currentIndex: getCurrentQuizIndex(state),
  loadingStatus: getStatus(state),
  hasNextQuiz: getHasNextQuiz(state),
  postConcepts: getConcepts(state),
  selectedConceptIndex: getSelectedConceptIndex(state),
});

function QuizBlock({
  t,
  quizzes,
  currentIndex,
  fetchNextQuiz,
  postQuizAnswer,
  hasNextQuiz,
  changeQuizIndex,
  postConcepts,
  changeConcept,
  fetchQuizHistory,
  selectedConceptIndex,
  loadingStatus,
}) {
  const conatinerElement = useRef(null);
  const {
    has_latex: hasLatex,
    description,
    images,
    correct_ans: correctAns,
    ft_size: fontSize,
  } = quizzes[currentIndex];
  const isLatestQuiz = currentIndex === quizzes.length - 1 && !hasNextQuiz;
  const conceptsItem = postConcepts.map(p => ({ id: p.qms_id, descr: p.name }));
  const isLoading = loadingStatus === LOADING;

  const clickSubmit = answerIndex => {
    const isCorrect = correctAns === answerIndex;
    quizzes[currentIndex].answer = isCorrect;
    postQuizAnswer({ answer: answerIndex, isCorrect });
  };
  const clickNext = () => {
    fetchNextQuiz();
    conatinerElement.current.scrollIntoView();
  };
  const clickNumber = index => () => changeQuizIndex(index);
  const changeFilterIndex = index => {
    changeConcept(conceptsItem[index].id);
    fetchQuizHistory();
  };

  return (
    <section className={styles.root}>
      {isLoading ? (
        <div className={styles.loader}>
          <SnapaskLoader />
        </div>
      ) : (
        <div
          className={styles.container}
          style={{ fontSize }}
          ref={conatinerElement}
        >
          <header className={styles.header}>
            <h3>{t('quizzes.title')}</h3>
            <ItemFilter
              items={conceptsItem}
              selectedIndex={selectedConceptIndex}
              changeIndex={changeFilterIndex}
            />
            <QuizNumberList
              quizzes={quizzes}
              currentIndex={currentIndex}
              clickNumber={clickNumber}
            />
          </header>
          <QuestionBlock
            hasLatex={hasLatex}
            description={description}
            images={images}
            theme={quizBlockTheme}
          />
          <AnswerBlock
            isLatestQuiz={isLatestQuiz}
            clickNext={clickNext}
            clickSubmit={clickSubmit}
          />
        </div>
      )}
    </section>
  );
}

QuizBlock.propTypes = {
  changeConcept: func.isRequired,
  changeQuizIndex: func.isRequired,
  currentIndex: number.isRequired,
  fetchNextQuiz: func.isRequired,
  fetchQuizHistory: func.isRequired,
  hasNextQuiz: bool.isRequired,
  loadingStatus: string.isRequired,
  postConcepts: array.isRequired,
  postQuizAnswer: func.isRequired,
  quizzes: array.isRequired,
  selectedConceptIndex: number.isRequired,
  t: func.isRequired,
};

export default compose(
  connect(mapStateToProps, {
    fetchNextQuiz: actions.fetchNextQuiz,
    postQuizAnswer: actions.postQuizAnswer,
    changeQuizIndex: actions.changeQuizIndex,
    fetchQuizHistory: actions.fetchQuizHistory,
    changeConcept: actions.changeConcept,
  }),
  translate(['quizzes'])
)(QuizBlock);



// WEBPACK FOOTER //
// ./app/containers/Post/components/PostContent/components/ContentBlock/components/QuizBlock/QuizBlock.jsx